import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { DsButtonKind } from '@frontend/ui/button';
import { Store } from '@ngrx/store';

import { IBetslipRootState } from '../../../../../base/store/state';
import { OverAskMessagesProvider } from '../../../services/over-ask-messages.provider';
import { BetslipOverAskPlaceBetButtonBaseComponent } from '../../betslip-over-ask-place-bet-button-base.component';

@Component({
    selector: 'bs-digital-over-ask-place-bet-button',
    templateUrl: './betslip-over-ask-place-bet-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./betslip-over-ask-place-bet-button.component.scss'],
    standalone: false,
})
export class BetslipOveraskPlaceBetButtonComponent extends BetslipOverAskPlaceBetButtonBaseComponent {
    @HostBinding('class.betslip-overask-place-bet-button') hostCssClass = true;
    @Input() override props: {
        hasOfferChanges: boolean;
    };

    readonly buttonThemeKind: ThemeOptions<DsButtonKind> = { 'mgm-4': 'primary', 'sports-interaction': 'primary' };

    constructor(store: Store<IBetslipRootState>, changeDetertor: ChangeDetectorRef, overAskMessagesProvider: OverAskMessagesProvider) {
        super(store, changeDetertor, overAskMessagesProvider);
    }
}
